import ReverseHangman from './ReverseHangman';

export default ReverseHangman;
